module.exports = __webpack_public_path__ + "static/media/main.f5b0c648.png";